import React, { useCallback } from 'react'
import Modal from 'react-modal'
import { useAuthState } from 'context'
import axios from 'axios'
import { InvisibleSmartCaptcha } from '@yandex/smart-captcha'
import { useEffect, useState } from 'react'
import { Formik, Form, Field } from 'formik'
import { Loader } from 'components/loader/loader'

Modal.setAppElement('#root')

export const CallbackModal = ({ isOpen, setIsOpen, setSuccess }) => {
  const { userDetails } = useAuthState()
  const [isLoading, setIsLoading] = useState(false)
  const [errorSend, setErrorSend] = useState('')
  const [token, setToken] = useState('')
  const [visible, setVisible] = useState(false)
  const handleChallengeHidden = useCallback(() => setVisible(false), [])

  useEffect(() => {
    if (token) {
      setErrorSend('')
    }
  }, [token])

  const customStyles = {
    overlay: {
      backgroundColor: 'rgba(47, 128, 237, 0.5)',
      position: 'fixed',
      display: 'flex',
      justifyContent: 'center',
      top: '0',
      left: '0',
      width: '100%',
      height: '100%',
      zIndex: 9,
      overflowY: 'auto',
    },
    content: {
      position: 'absolute',
      backgroundColor: '#FFFFFF',
      borderRadius: '10px',
      height: 'fit-content',
      margin: '10px auto',
      maxWidth: '540px',
      width: '95%',
      outlineWidth: 0,
    },
  }

  const makeName = (user) => {
    let res = ''
    if (user) {
      res += user.surname ? user.surname : ''
      res += user.name ? ' ' + user.name : ''
      res += user.patronymic ? ' ' + user.patronymic : ''
    }
    return res
  }

  const validate = (values) => {
    setVisible(true)
    const errors = {}
    if (!values.name) {
      errors.name = 'Обязательное поле'
    }
    if (!values.email) {
      errors.email = 'Обязательное поле'
    }
    if (
      values.email &&
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
    ) {
      errors.email = 'Неверный адрес электронной почты'
    }
    if (!values.description.length > 0) {
      errors.description = 'Обязательное поле'
    }
    if (!values.personal_data_confirmation) {
      errors.personal_data_confirmation = 'Обязательное поле'
    }
    return errors
  }

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={() => {
        setIsOpen(false)
      }}
      overlayClassName={'modal_overlay'}
      className={'modal'}
      style={customStyles}
      contentLabel="Отзыв"
      shouldCloseOnOverlayClick={true}
    >
      <div className="modal__phone">
        <h2 className="modal__title">Отзыв</h2>
        <div className="modal__wrap">
          <Formik
            initialValues={{
              name: makeName(userDetails),
              email: '',
              description: '',
              personal_data_confirmation: false,
            }}
            validate={(values) => {
              return validate(values)
            }}
            onSubmit={async (values) => {
              if (token) {
                setIsLoading(true)
                return axios
                  .post(`${process.env.REACT_APP_BACKEND}/feed-back/store`, {
                    name: values.name,
                    email: values.email,
                    content: values.description,
                    personal_data_confirmation:
                      values.personal_data_confirmation,
                  })
                  .then(() => {
                    setSuccess()
                  })
                  .catch((e) => {
                    setErrorSend(
                      e?.response?.data?.message || 'Что то пошло не так...',
                    )
                  })
                  .finally(() => setIsLoading(false))
              } else {
                setErrorSend('Ошибка проверки капчи')
                setIsLoading(false)
              }
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleReset,
              handleSubmit,
              isValid,
            }) => (
              <Form
                className="authorization__form authorization__form_2 js-authorization-form"
                onSubmit={handleSubmit}
              >
                {errorSend ? (
                  <>
                    <div className="authorization__subtitle">
                      Ошибка отправки
                    </div>
                    <div className="authorization__subtitle">{errorSend}</div>
                  </>
                ) : (
                  <>
                    <div className="authorization__input-group">
                      <div className="authorization__input-block w-full">
                        <label htmlFor="name">Ваше имя</label>
                        <Field
                          id="name"
                          name="name"
                          type="text"
                          placeholder="Ваше имя"
                          onChange={handleChange}
                          value={values.name}
                          disabled={userDetails?.name}
                        />
                        <span className="authorization__error">
                          {errors.name && touched.name && errors.name}
                        </span>
                      </div>
                    </div>
                    <div className="authorization__input-group">
                      <div className="authorization__input-block w-full">
                        <label htmlFor="email">Ваш e-mail</label>
                        <Field
                          id="email"
                          name="email"
                          type="text"
                          placeholder="Ваш e-mail"
                          onChange={handleChange}
                          value={values.email}
                        />
                        <span className="authorization__error">
                          {errors.email && touched.email && errors.email}
                        </span>
                      </div>
                    </div>
                    <div className="authorization__input-group">
                      <div className="authorization__input-block w-full">
                        <label htmlFor="description">Отзыв</label>
                        <Field
                          id="description"
                          name="description"
                          type="textarea"
                          component="textarea"
                          placeholder="Напишите свой отзыв здесь..."
                          onChange={handleChange}
                          value={values.description}
                        />
                        <span className="authorization__error">
                          {errors.description &&
                            touched.description &&
                            errors.description}
                        </span>
                      </div>
                    </div>
                    <div className="authorization__input-group">
                      <div className="authorization__checkbox-block">
                        <label htmlFor="personal_data_confirmation">
                          <Field
                            id="personal_data_confirmation"
                            name="personal_data_confirmation"
                            type="checkbox"
                            onChange={handleChange}
                          />
                          <span>
                            Я даю{' '}
                            <a
                              target={'_blank'}
                              rel="noreferrer"
                              href="https://er.ru/upages/personal"
                            >
                              согласие на обработку{' '}
                            </a>
                            моих персональных данных в соответствии ФЗ №152-ФЗ
                            «О персональных данных» и на
                            <a
                              target={'_blank'}
                              rel="noreferrer"
                              href="https://er.ru/upages/privacy-policy"
                            >
                              {' '}
                              Политику конфиденциальности
                            </a>
                          </span>
                        </label>
                        <span className="authorization__error">
                          {errors.personal_data_confirmation &&
                            touched.personal_data_confirmation &&
                            errors.personal_data_confirmation}
                        </span>
                      </div>
                    </div>
                    <div className="authorization__input-group captcha">
                      <div className="authorization__input-block">
                        <InvisibleSmartCaptcha
                          sitekey={process.env.REACT_APP_YANDEX_CAPTCHA}
                          onSuccess={setToken}
                          onChallengeHidden={handleChallengeHidden}
                          visible={visible}
                          hideShield={true}
                        />
                      </div>
                    </div>
                  </>
                )}
                <div className="authorization__input-group buttons">
                  <div className="authorization__input-button">
                    <button
                      className="btn btn-clean authorization__btn-submit button"
                      type="button"
                      onClick={() => {
                        setIsOpen(false)
                      }}
                    >
                      <span>отменить</span>
                    </button>
                  </div>
                  <div className="authorization__input-button">
                    {errorSend ? (
                      <button
                        className="btn btn-red authorization__btn-submit button"
                        type="button"
                        onClick={() => {
                          setErrorSend('')
                          handleReset()
                        }}
                      >
                        <span>Повторить</span>
                      </button>
                    ) : (
                      <button
                        className="btn btn-red authorization__btn-submit button"
                        type="submit"
                        disabled={!isValid || isLoading || !token}
                      >
                        {isLoading && <Loader />}
                        <span style={{ opacity: isLoading ? 0 : 1 }}>
                          Отправить
                        </span>
                      </button>
                    )}
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </Modal>
  )
}
